<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4.847 21.971c.026-.032.054-.062.083-.092L22.492 4.34a1.17 1.17 0 011.835.236l3.231 3.212c.076.075.14.158.19.247a1.153 1.153 0 01-.086 1.535L10.077 27.178a1.165 1.165 0 01-.79.342.781.781 0 01-.07.01l-4.423.466a.716.716 0 01-.79-.785l.469-4.396a.731.731 0 01.04-.176 1.15 1.15 0 01.331-.665l.003-.003z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsPencilFilled'
}
</script>
